// extracted by mini-css-extract-plugin
export default {"indicator":"theme_indicator__ygx6N","absolute":"theme_absolute__7I5I8","slide":"theme_slide__bwG8L"};